module.exports = __webpack_public_path__ + "static/media/placeholder.938cc162.jpg";